var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmailScheduled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "email-scheduled_svg__a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#email-scheduled_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.192 18.539V5.385l12.281 5.25h-.07q-.45.038-.909.133a3.7 3.7 0 0 0-.798.251L5.192 7v3.885L10.04 12l-4.847 1.116V17l6.035-2.57q-.123.287-.204.629a4 4 0 0 0-.1.576v.011zm12.616 2.077q-1.671 0-2.836-1.165-1.164-1.164-1.164-2.835t1.164-2.836 2.836-1.164q1.672 0 2.835 1.164 1.165 1.164 1.165 2.836t-1.165 2.835-2.835 1.165m1.65-1.804.546-.547-1.812-1.811v-2.723h-.769v3.046z"
}))));
export default SvgEmailScheduled;